<template>
  <div class="media-input">
    <img v-if="thumb" :src="thumb" alt="" class="form__thumb">
    <button class="btn btn--small btn__default" :value="value" @click.prevent="mediaManager = true">Agregar Imagen</button>
    <button v-if="thumb" @click.prevent="removeImage" class="btn btn__transparent btn--small">Quitar Imagen</button>
    <popup-viewer name="image" @close="mediaManager = false" v-if="mediaManager"></popup-viewer>
  </div>
</template>

<script>
import popupViewer from '@/components/media/popup'
export default {
  props: {
    value: {
      type: Object,
      required: false,
      detault: function () {
        return null
      }
    }
  },
  components: {popupViewer},
  data: function () {
    return {
      mediaManager: false,
      thumb: null
    }
  },
  created: function () {
    this.setThumb()
  },
  watch: {
    value: function () {
      this.setThumb()
    }
  },
  mounted: function () {
    this.$on('image', image => {
      this.setThumb(image)
      let img = image
      this.$emit('input', img)
      this.mediaManager = false
    })
  },
  methods: {
    setThumb: function () {
      if (this.value) {
        this.thumb = this.value.images.thumb[0]
      } else {
        this.thumb = null
      }
    },
    removeImage: function () {
      this.thumb = null
      this.$emit('input', null)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/media/input.vue